<template>
    <div>
<!--        Login form activated by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
        <span v-html="$t('notification.loginFormActivated', {user:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "LoginFormActivated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
